export default __webpack_public_path__ + "static/media/team_shuffle_shuffle.c81258c5.webm";